import React from 'react';
import { Navigate } from 'react-router-dom';
import { useEduAuth } from '../context/EduAuthContext';

export default function EduProtectedRoute({ children }) {
  const { eduUser } = useEduAuth();

  if (eduUser === null) {
    return (
      <div className="min-h-screen bg-[#0d0d10] flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-purple-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!eduUser) {
    return <Navigate to="/edu/login" replace />;
  }

  return children;
}
